"use client";
import { useTranslations } from "next-intl";
import { Separator } from "@/components/ui/separator";
import { formatPrice } from "@/lib/utils";
import { cn } from "@/lib/utils";

type Props = {
  subtotal: number;
  shippingTotal: number;
  serviceFee: number;
  currencyCode?: string;
  className?: string;
  showTotal?: boolean;
};

export function OrderSummary({
  subtotal, shippingTotal, serviceFee,
  currencyCode = "USD",
  className = "",
  showTotal = true,
}: Props) {
  const t = useTranslations("sellerGroup");
  const total = subtotal + shippingTotal + serviceFee;
  const labelCls = "text-muted-foreground";
  const valueCls = "text-foreground";
  return (
    <div className={`grid gap-2 ${className} text-foreground`}>
      <div className="flex justify-between">
        <span className={labelCls}>Subtotal</span>
        <span className={valueCls}>{formatPrice(subtotal, currencyCode)}</span>
      </div>
      <div className="flex justify-between">
        <span className={labelCls}>Shipping</span>
        <span className={valueCls}>{formatPrice(shippingTotal, currencyCode)}</span>
      </div>
      <div className="flex justify-between">
        <span className={labelCls}>Service Fees</span>
        <span className={valueCls}>{formatPrice(serviceFee, currencyCode)}</span>
      </div>
      {showTotal && (
        <>
          {/* `showTotal` is false at the only former dark call site
              (`checkout-form`), so this separator has only ever rendered on the
              theme-driven `cart-footer` branch — the dropped `dark &&
              "bg-neutral-700"` was unreachable. */}
          <Separator className="my-2" />
          <div className={cn("flex justify-between font-semibold text-lg", valueCls)}>
            <span>Total</span>
            <span>{formatPrice(total, currencyCode)}</span>
          </div>
        </>
      )}
    </div>
  );
}
